// removed by extract-text-webpack-plugin
module.exports = {"social":"_1Oy5u","label":"_1l--n","item":"_KIIy","facebook":"_3l1l-","twitter":"_3FC0x"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/Social/styles.css
 ** module id = 348
 ** module chunks = 0
 **/